import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Preloader from "./components/Preloader";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Menu from "./pages/Menu";
import MenuItems from "./pages/MenuItems";
import LunchMenu from "./pages/LunchMenu";
import DrinksMenu from "./pages/DrinksMenu";
import AlcoholMenu from "./pages/AlcoholMenu";
import OurChefs from "./pages/OurChefs";
import About from "./pages/About";
import Reservation from "./pages/Reservation";
import Gallery from "./pages/Gallery";
import Events from "./pages/Events";
import EventDetail from "./pages/EventDetail";
import Contact from "./pages/Contact";
import Order from "./pages/Order";
import NotFound from "./pages/NotFound";
import RestaurantVideo from "./pages/RestaurantVideo";
import { Toaster } from "./components/ui/toaster";
import { I18nProvider } from "./data/i18n";
import Seo from "./components/Seo";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <I18nProvider>
        <BrowserRouter>
          <Preloader />
          <ScrollToTop />
          <Seo />
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/menu" element={<Menu />} />
              <Route path="/menu/items" element={<MenuItems />} />
              <Route path="/menu/lunch" element={<LunchMenu />} />
              <Route path="/menu/drinks" element={<DrinksMenu />} />
              <Route path="/menu/alcohol" element={<AlcoholMenu />} />
              <Route path="/chefs" element={<OurChefs />} />
              <Route path="/about" element={<About />} />
              <Route path="/reservation" element={<Reservation />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/events" element={<Events />} />
              <Route path="/events/:id" element={<EventDetail />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/order" element={<Order />} />
              <Route path="/videos/casa-bala-restaurant-sofia" element={<RestaurantVideo />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
          <Toaster />
        </BrowserRouter>
      </I18nProvider>
    </div>
  );
}

export default App;
